'use strict';

class AcceptableUsePolicyView {
  constructor() {
    'ngInject';
  }
}

export default AcceptableUsePolicyView;
